import type { Agent } from "@/types/agent/agent";
import type { GenieDocumentBrand } from "@/types/genie-documents/genie-document";
import { DEFAULT_BRANDING } from "@/types/ui/branding";

/**
 * The co-branding a generated document carries: the customer's brand leads, the
 * Help Genie mark sits alongside it. Resolved in one place so the preview, the
 * PDF and the library card can never disagree about a Genie's colours.
 */
export const genieDocumentBrand = (agent: Partial<Agent> | undefined | null): GenieDocumentBrand => ({
  name: agent?.branding?.brandName || agent?.name || "Your Business",
  tagline: agent?.branding?.tagline || null,
  logoUrl: agent?.branding?.logoUrl || agent?.branding?.customAvatarUrl || null,
  primaryColor: agent?.branding?.primaryColor || DEFAULT_BRANDING.primaryColor,
  secondaryColor: agent?.branding?.secondaryColor || DEFAULT_BRANDING.secondaryColor || "#FF4DB8",
});
